import React from 'react';

/** Stylized grayscale map of the Miami Lakes area. */
export function StylizedMap() {
  return <svg viewBox="0 0 600 460" role="img" aria-label="Map of Miami Lakes showing the location of Lima Dental Group at 15600 NW 67th Ave #106" className="h-[300px] w-full lg:h-[380px]" data-id="element-469" data-mp="1ju5ury5oy33o">
      <rect width="600" height="460" fill="#ededeb" data-id="element-470" data-mp="1a2rn333l5wzg" />
      <g fill="#e2e2df" data-id="element-471" data-mp="w41otk515r9i">
        <rect x="30" y="30" width="180" height="120" data-id="element-472" data-mp="w3ihsygx4na9" />
        <rect x="240" y="30" width="150" height="120" data-id="element-473" data-mp="w64okvvziyrf" />
        <rect x="420" y="30" width="150" height="90" data-id="element-474" data-mp="114679fpi0w2d" />
        <rect x="30" y="185" width="180" height="110" data-id="element-475" data-mp="110s62askmswi" />
        <rect x="240" y="185" width="150" height="110" data-id="element-476" data-mp="m75ow2t76dgk" />
        <rect x="420" y="155" width="150" height="140" data-id="element-477" data-mp="r4p3j3tt4s91" />
        <rect x="30" y="330" width="180" height="100" data-id="element-478" data-mp="r5gwe6w0sbvm" />
        <rect x="240" y="330" width="330" height="100" data-id="element-479" data-mp="2gjdhh9i1qi96" />
      </g>
      <g stroke="#ffffff" strokeWidth="10" data-id="element-480" data-mp="2gi2c558yd2fy">
        <line x1="225" y1="0" x2="225" y2="460" data-id="element-481" data-mp="2lj83aymyshnd" />
        <line x1="405" y1="0" x2="405" y2="460" data-id="element-482" data-mp="2lglz98za8k9w" />
        <line x1="0" y1="168" x2="600" y2="168" data-id="element-483" data-mp="20vlk5shq4qe8" />
        <line x1="0" y1="313" x2="600" y2="313" data-id="element-484" data-mp="20uagdsoa3in4" />
      </g>
      <g stroke="#f6f6f4" strokeWidth="4" data-id="element-485" data-mp="1vwr3aw3bhbwr">
        <line x1="120" y1="0" x2="120" y2="460" data-id="element-486" data-mp="1vvppijux2bbc" />
        <line x1="500" y1="0" x2="500" y2="460" data-id="element-487" data-mp="2aleyv2d5xlmp" />
        <line x1="0" y1="90" x2="600" y2="90" data-id="element-488" data-mp="2ao9jov0398gn" />
        <line x1="0" y1="390" x2="600" y2="390" data-id="element-489" data-mp="25oeseqceigv2" />
      </g>
      <rect x="430" y="330" width="140" height="100" fill="#e5e5e2" data-id="element-490" data-mp="1hxrcbhsc0kxf" />
      <g transform="translate(300 200)" data-id="element-491" data-mp="1hy149awxt25r">
        <circle r="34" fill="#050505" opacity="0.07" data-id="element-492" data-mp="1cz7r5jlkbd64" />
        <path d="M0 -30c-9.94 0-18 8.06-18 18 0 13.5 18 32 18 32s18-18.5 18-32c0-9.94-8.06-18-18-18z" fill="#050505" data-id="element-493" data-mp="1d0iyfte7v31z" />
        <circle cx="0" cy="-12" r="5.5" fill="#e3262e" data-id="element-494" data-mp="1mwcg1r6slmqm" />
      </g>
      <text x="300" y="252" textAnchor="middle" fill="#050505" fontSize="13" fontFamily="Manrope, sans-serif" fontWeight="600" letterSpacing="1" data-id="element-495" data-mp="1mz8fjjyagjh6">
        LIMA DENTAL GROUP
      </text>
    </svg>;
}